var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.currentComponent,{ref:"currentComponent",tag:"component"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOverlay),expression:"showOverlay"}],staticClass:"overlay",on:{"click":_vm.resetPrompts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }